const doc = [({"en":({"js":({"steps":({"timer":"Timer"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;